/** Maximum count of operations inside an event stats */
export const MAX_STATS_LIMIT = 50;
/** Wait for this amount of time ( in ms ) before sending stats events to telemetry */
export const STATS_WAIT_TIME_IN_SECONDS = 10000;
/** The telemetry table name suffix for the event stats table */
export const STATS_TABLE = 'EventStats';
/** Buffer for event stats. */
export class EventStatsBuffer {
    constructor() {
        this.clearEventStats();
    }
    /** Method to return an eventstats event */
    clearEventStats(lastSentTime) {
        this.stats = {
            eventsList: {},
            totalCount: 0,
            lastSentTime,
        };
    }
    /** Method to check if the conditions for sending a stats telemetry event to telemetry are met */
    shouldSendStatsToTelemetry() {
        const eventCount = this.stats.totalCount;
        if (eventCount === 0)
            return false;
        if (eventCount > MAX_STATS_LIMIT)
            return true;
        if (this.stats.lastSentTime !== undefined && Date.now() - this.stats.lastSentTime >= STATS_WAIT_TIME_IN_SECONDS)
            return true;
        return false;
    }
    /** This method sets the fields in the EventStats object */
    prepareEventStatsEvent(event, operationAndLogType, sequenceNumber) {
        if (operationAndLogType in event.eventsList) {
            event.eventsList[operationAndLogType].push(sequenceNumber);
        }
        else {
            event.eventsList[operationAndLogType] = [sequenceNumber];
        }
        event.totalCount += 1;
    }
}
//# sourceMappingURL=eventStatsBuffer.js.map